import { BaseModel } from './baseModel';
import { ProfileSettings } from './profileSettings';

// Profile status enum
export enum ProfileStatus {
  Active = 'active',
  Pending = 'pending',
  Deleted = 'deleted',
  Suspended = 'suspended',
}

export interface ProfileMetadata {
  settings: ProfileSettings;
  doNotShow?: {
    walkthrough?: boolean;
    walkthrough_user?: boolean;
  };
}

export interface UserPlan extends BaseModel {
  seatPriceMonthly?: number;
  seatPriceAnnual?: number;
  trial: UserTrial[];
}

export interface UserTrial {
  status: 'active' | 'expired';
  certificationId: string;
  expires: string;
}

export interface Profile extends Omit<BaseModel, 'metadata'> {
  metadata: ProfileMetadata;
  status: ProfileStatus;
  userId: string;
  extUserId: string | null;
  default: boolean;
  persona: string;
  roles: string[];
  email: string;
  displayName: string;
  firstName: string;
  lastName: string;
  initials: string | null;
  avatarUrl: string | null;
  timezone: string;
  invitedById: string;
  invitationAcceptedAt: string | null;
  invitationRejectedAt: string | null;
  hubSpotId: string | null;
  businessId: string;
  lastSeenUpdate: string | null;
  invitationAck: boolean;
  userPlan?: UserPlan;
}

// Simplified profile for invitation context
export interface InvitedByProfile {
  profileId: string;
  displayName: string;
  avatarUrl: string | null;
  userId: string;
  persona: string;
}

// Helper function to check if profile is a team owner
export function isTeamOwner(profile: Profile | null | undefined): boolean {
  return !!(profile && profile.roles?.includes('owner'));
}

// Helper function to check if profile is a team admin
export function isTeamAdmin(profile: Profile | null | undefined): boolean {
  return !!(profile && profile.roles?.includes('admin'));
}

// Helper function to check if profile is a team admin
export function isTeamOwnerOrAdmin(profile: Profile | null | undefined): boolean {
  return !!(profile && (profile.roles?.includes('admin') || profile.roles?.includes('owner')));
}